module.exports = __webpack_public_path__ + "accelerated-results.2qgq5PP5.svg";